import Bungawari1 from './Bungawari (1).webp'
import Bungawari2 from './Bungawari (2).webp'
import Bungawari3 from './Bungawari (3).webp'
import Bungawari4 from './Bungawari (4).webp'
import Bungawari5 from './Bungawari (5).webp'
import Bungawari6 from './Bungawari (6).webp'
import Bungawari7 from './Bungawari (7).webp'
import Bungawari8 from './Bungawari (8).webp'
import Bungawari9 from './Bungawari (9).webp'
import Bungawari10 from './Bungawari (10).webp'
import Bungawari11 from './Bungawari (11).webp'
import Bungawari12 from './Bungawari (12).webp'



const Bungawariimages =[
Bungawari1,Bungawari2,Bungawari3,Bungawari4,Bungawari5,Bungawari6,Bungawari7,Bungawari8,Bungawari9,Bungawari10,Bungawari11,Bungawari12
]

export default Bungawariimages;